module.exports = __webpack_public_path__ + "68253a633512c50b1ce70aed68fe05ee.svg";